import React from "react";
import { AlertTriangle } from "lucide-react";

/** Erreur serveur / métier après chargement (ex. HTTP 500). */
export default function FinanceApiErrorBanner({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}): React.JSX.Element {
  return (
    <div
      role="alert"
      className="flex flex-col gap-3 rounded-2xl border border-red-500/40 bg-red-950/40 px-4 py-4 text-left sm:flex-row sm:items-center sm:justify-between"
    >
      <div className="flex gap-3">
        <AlertTriangle className="h-5 w-5 shrink-0 text-red-400" aria-hidden />
        <div>
          <p className="text-sm font-semibold text-red-100">Erreur métier</p>
          <p className="mt-1 text-sm text-red-200/90">{message}</p>
        </div>
      </div>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="shrink-0 rounded-lg border border-red-400/50 bg-red-900/50 px-4 py-2 text-sm font-medium text-white hover:bg-red-900/80"
        >
          Réessayer
        </button>
      ) : null}
    </div>
  );
}
